import { Component } from '@angular/core';

@Component({
  selector: 'app-why-now',
  standalone: true,
  imports: [],
  templateUrl: './why-now.component.html',
  styleUrl: './why-now.component.scss'
})
export class WhyNowComponent {

}
